// app/src/api/core/serverApi.ts

import { createServerAxiosInstance } from "./axiosBase"
import { limitedRequest } from "./limiter"
import { addIdempotencyKey, preventDuplicateRequest } from "./idempotency"

// 기본 axios 인스턴스 생성
const baseServerApi = createServerAxiosInstance()

/**
 * p-limit과 멱등키가 적용된 serverApi 객체
 * 모든 HTTP 메서드에 동시 요청 제한과 POST 재시도 안전화가 적용됩니다.
 */
export const serverApi = {
  get: <T = any>(url: string, config?: any): Promise<any> => limitedRequest(() => baseServerApi.get<T>(url, config) as Promise<any>),

  post: <T = any>(url: string, data?: any, config?: any): Promise<any> =>
    preventDuplicateRequest("POST", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "POST")
      return limitedRequest(() => baseServerApi.post<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  put: <T = any>(url: string, data?: any, config?: any): Promise<any> =>
    preventDuplicateRequest("PUT", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "PUT")
      return limitedRequest(() => baseServerApi.put<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  patch: <T = any>(url: string, data?: any, config?: any): Promise<any> =>
    preventDuplicateRequest("PATCH", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "PATCH")
      return limitedRequest(() => baseServerApi.patch<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  delete: <T = any>(url: string, config?: any): Promise<any> => limitedRequest(() => baseServerApi.delete<T>(url, config) as Promise<any>),

  // 인터셉터 호환성을 위한 참조
  interceptors: baseServerApi.interceptors,
}
